import { defineSemanticTokens, defineTokens } from '@chakra-ui/react';

import { colors, semanticColors } from './colors';
import { gradients } from './gradients';
import { spacing } from './spacing';
import { fonts, fontSizes, fontWeights } from './typography';

export const tokens = defineTokens({
  colors,
  gradients,
  spacing,
  fonts,
  fontSizes,
  fontWeights,
  shadows: {
    right: { value: '8px 0 16px 0 var(--chakra-colors-neutral-black-op50)' },
  },
});

export const semanticTokens = defineSemanticTokens({
  colors: semanticColors,
});
